import { useSelector } from "react-redux";
import CollapsibleElement from "./CollapsibleElement";
import { PuzzlePieceSolidV6 } from "@shared/v2/Icomoon";

const Projects = () => {
  const projects = useSelector((state) => state.personDetail.projects);

  if (!projects?.length) return null;

  return (
    <CollapsibleElement title="Projects" id="pdp-projects">
      <div className="tw-flex tw-flex-col tw-gap-[16px]">
        {projects.map(({ id, name, type }) => (
          <div key={id} className="tw-shadow-card tw-rounded-[6px] tw-p-[8px] tw-flex tw-gap-[8px]">
            <a
              href={`/projects/${id}`}
              target="_blank"
              className="tw-w-[40px] tw-h-[40px] tw-flex-none tw-flex tw-justify-center tw-items-center tw-rounded-[4px] tw-bg-[rgba(89,196,196,0.2)] tw-text-brand-info hover:tw-text-brand-info hover:tw-opacity-80"
            >
              <PuzzlePieceSolidV6 size="xl" />
            </a>
            <div className="tw-flex-1 tw-flex tw-flex-col tw-overflow-hidden tw-whitespace-nowrap">
              <a
                href={`/projects/${id}`}
                target="_blank"
                className="tw-overflow-hidden tw-text-ellipsis"
                title={name}
              >
                {name}
              </a>
              <div className="tw-text-12d tw-overflow-hidden tw-text-ellipsis" title={type}>
                {type}
              </div>
            </div>
          </div>
        ))}
      </div>
    </CollapsibleElement>
  );
};

export default Projects;
